import Style from "../../css/style.module.css";
import strFunc from '@/lib/lyg/string';
import left_arrow_ico from "@/img/ico/arrow/left_arrow.png";
import right_arrow_ico from "@/img/ico/arrow/right_arrow.png";
import DateFunc from '@/lib/lyg/date_func';

function TopSearchDayArea(props:any){
  let myProps={
    listOpt:{},
    list:(inData:any)=>{},
    select_date:"",
    set_select_date:(inData:any)=>{},
    onSearchDateChange:(inData:any)=>{},
    ...props
  };
  let listOpt=myProps.listOpt;
  let today_date_str=DateFunc.get_date_format(new Date(),"Y-m-d");
  let select_day_date_json=DateFunc.get_date_json(new Date(myProps.select_date));
  let pre_day_date_json=DateFunc.get_date_json(DateFunc.get_change_date(new Date(myProps.select_date),'day',-1));
  let after_day_date_json=DateFunc.get_date_json(DateFunc.get_change_date(new Date(myProps.select_date),'day',+1));
  let day_name_list=["일","월","화","수","목","금","토"];

  const handleDateChange = (inData: any) => {
    let opt_obj = {
      ...inData
    };//s_year,s_month
    let name = opt_obj.target.name;
    let value = opt_obj.target.value;
    let tmp_select_date = listOpt.s_addon_todo_start_date;

    let tmp_year = tmp_select_date.substring(0, 4);
    let tmp_month = tmp_select_date.substring(5, 7);
    let tmp_day = tmp_select_date.substring(8, 10);
    let tmp_date_json: any = DateFunc.get_date_json(new Date(tmp_select_date));
    if (name == "s_month") {
      tmp_month = value;
    } else if (name == "s_year") {
      tmp_year = value;
    } else if (name == "s_day") {
      tmp_day = value;
    }
    if (parseInt(tmp_day) > tmp_date_json.last_day) {
      tmp_day = strFunc.str_pad({ "str": tmp_date_json.last_day, "pad_length": 2 });
    }
    tmp_select_date = tmp_year + "-" + tmp_month + "-" + tmp_day;

    myProps.list({
      s_addon_todo_start_date: tmp_select_date,
      s_addon_todo_end_date: tmp_select_date,
    });
  };

  const goPrevAfter=(sort:"prev"|"after")=>{
    let select_month_obj=new Date(myProps.select_date);
    let change_date_str="";
    if(sort=="prev"){
      change_date_str=DateFunc.get_date_format(DateFunc.get_change_date(select_month_obj,'day',-1),"Y-m-d");
    }else{
      change_date_str=DateFunc.get_date_format(DateFunc.get_change_date(select_month_obj,'day',+1),"Y-m-d");
    }
    myProps.set_select_date(change_date_str);
    myProps.onSearchDateChange(change_date_str);
  };

  let year_num_arr=[];
  let select_year_num=parseInt(myProps.select_date.substring(0,4));
  for(let i=select_year_num-50;i<=select_year_num+10;i++){
    year_num_arr.push(i);
  }
  const year_options_tag=year_num_arr.map((item,idx)=>{
    return (
      <option value={item} key={idx}>{item}</option>
    );
  });

  let month_num_arr=[];
  for(let i=1;i<=12;i++){
    month_num_arr.push(i);
  }
  const month_options_tag=month_num_arr.map((item:any,idx:number)=>{
    let month_val=strFunc.str_pad({"str":item,"pad_length":2});
    return (
      <option value={month_val} key={idx}>{item}</option>
    );
  });

  let day_num_arr=[];
  for(let i=1;i<=select_day_date_json.t;i++){
    day_num_arr.push(i);
  }
  const day_options_tag=day_num_arr.map((item:any,idx:number)=>{
    let month_val=strFunc.str_pad({"str":item,"pad_length":2});
    return (
      <option value={month_val} key={idx}>{item}</option>
    );
  });

  return (
    <div className={Style.top_year_month_wrap}>
      <div className={Style.year_span_wrap}>
        <span className={Style.top_year_month_side_span+" mr-2"}>
          {pre_day_date_json.m}월 {pre_day_date_json.d}일
        </span>
        <span className={Style.year_arrow_btn} onClick={()=>{goPrevAfter("prev");}}>
          <img  src={left_arrow_ico} />
        </span>
        <span className={Style.center_ym_span}>
          <select className="ml-1" name="s_month" value={myProps.select_date.substring(5,7)} onChange={handleDateChange}>
            {month_options_tag}
          </select>월
          <select className="ml-1" name="s_day" value={myProps.select_date.substring(8,10)} onChange={handleDateChange}>
            {day_options_tag}
          </select>일
          
            <div className={Style.center_ym_span_today_text}>
              {
                day_name_list[select_day_date_json.day]
              }
              {myProps.select_date==today_date_str&&
                <span>{" "}(오늘)</span>
              }
            </div>
         
        </span>
        <span className={Style.year_arrow_btn} onClick={()=>{goPrevAfter("after");}}>
          <img  src={right_arrow_ico} />
        </span>
        <span className={Style.top_year_month_side_span+" ml-2"}>
          {after_day_date_json.m}월 {after_day_date_json["d"]}일
        </span>
      </div>
    </div>
  );
}
export default TopSearchDayArea;